// In your payment status component
import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Swal from "sweetalert2";
import { REACT_APP_API_BASE_URL } from '../utils/constant';
import { FaBitcoin } from "react-icons/fa";





const Toast = Swal.mixin({
    toast: true,
    position: "top",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
});


function PaymentStatusPage({invoiceId, status, setStatus}) {
    const navigate = useNavigate();
    const [error, setError] = useState(null);
    const intervalRef = useRef();
    const [wiggle, setWiggle] = useState(false);


    const checkPaymentStatus = async () => {
        try {
            const response = await axios.get(`${REACT_APP_API_BASE_URL}blink-invoice/${parseInt(invoiceId)}/`);
            const newStatus = response.data.status;
            setStatus(newStatus.toLowerCase());

            if (newStatus.toLowerCase() === 'paid') {
                clearInterval(intervalRef.current);
                // navigate('/payment/success', { replace: true }); // Redirect on success
                Toast.fire({
                    icon: "success",
                    title: "Payment Successful",
                })
            } else if (newStatus.toLowerCase() === 'failed') {
                clearInterval(intervalRef.current);
                // navigate('/payment/failed', { replace: true }); // Redirect on failure
                    Toast.fire({
                    icon: "error",
                    title: "Payment Failed",
                })                }
        } catch (err) {
            setError('Failed to check payment status.');
            clearInterval(intervalRef.current);
            console.error(err);
        }
    };


    useEffect(() => {
        intervalRef.current = setInterval(checkPaymentStatus, 5000); // Poll every 5 seconds

        // Initial check immediately
        checkPaymentStatus();

        // Cleanup interval on component unmount
        return () => clearInterval(intervalRef.current);
    }, [invoiceId, status]);


    useEffect(() => {
    if (status === 'paid') {
        setWiggle(false); // Reset in case of re-entry
        setTimeout(() => setWiggle(true), 10); // Trigger wiggle after render
    }}, [status]);


    return (
        <div>
            {status === 'pending' && (
                <div className="payment-pending-container">
                    <div className="payment-pending-blink">
                        <p style={{margin: 0}}>Please scan the QR code or use the Lightning address to complete your payment!<br></br><i className="fas fa-spinner fa-spin"></i></p>
                    </div>
                </div>
                )}
            {status === 'paid' && (
                <div className="payment-success-container">
                    <div className={`payment-success-blink${wiggle ? ' wiggle' : ''}`}>
                        <p style={{ margin: 0 }}><span style={{ marginRight: "5px" }}><FaBitcoin /></span>Payment successful!</p>
                    </div>
                </div>
                )}
            {error && <p style={{color: 'red', textAlign: 'center'}}>{error}</p>}
        </div>
    );
}

export default PaymentStatusPage;